export default "__VITE_ASSET__CEd4DLRd__"